
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"49.99","cy":"50.04","rx":"39.99","ry":"39.95","fill":"none","stroke":"#f9b041","stroke-width":"14.9","stroke-linecap":"round","stroke-miterlimit":"10"}}),_c('g',[_c('animateTransform',{attrs:{"attributeName":"transform","attributeType":"XML","type":"rotate","from":"0 50 50","to":"360 50 50","dur":"2s","repeatCount":"indefinite"}}),_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"42.509","y1":"70.025","x2":"97.5","y2":"70.025"}},[_c('stop',{attrs:{"offset":".253","stop-color":"#913b8e"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9e5099"}})]),_c('path',{attrs:{"d":"M90 50.05C90 72.11 72.1 90 50.01 90","fill":"none","stroke":"url(#a)","stroke-width":"15","stroke-linecap":"round","stroke-miterlimit":"10"}}),_c('linearGradient',{attrs:{"id":"b","gradientUnits":"userSpaceOnUse","x1":"2.508","y1":"70.02","x2":"57.499","y2":"70.02"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#923b8e"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#923b8e"}})]),_c('path',{attrs:{"d":"M50 90c-22.09 0-39.99-17.89-39.99-39.95","fill":"none","stroke":"url(#b)","stroke-width":"15","stroke-linecap":"round","stroke-miterlimit":"10"}}),_c('linearGradient',{attrs:{"id":"c","gradientUnits":"userSpaceOnUse","x1":"2.508","y1":"30.064","x2":"57.499","y2":"30.064"}},[_c('stop',{attrs:{"offset":".237","stop-color":"#913b8e"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#772a73"}})]),_c('path',{attrs:{"d":"M10.01 50.04c0-22.06 17.9-39.95 39.99-39.95","fill":"none","stroke":"url(#c)","stroke-width":"15","stroke-linecap":"round","stroke-miterlimit":"10"}})])])
          )
        }
      }
    